import React from "react";
import NotFound from "@/pages/NotFound";
import { useAuth } from "../../../lib/auth";
import { usePortfolioFeature } from "../../../lib/portfolio";

export default function PortfolioGate({ children }) {
  const { user } = useAuth();
  const feature = usePortfolioFeature(user?.id);
  if (!feature) {
    return <div className="p-8 text-sm font-nav text-erf-dark/70" data-testid="portfolio-gate-loading">Loading…</div>;
  }
  if (!feature.enabled) return <NotFound />;
  return children;
}
